import React, { lazy, useState } from 'react';
import PieChartOperaDetails from './PieChartOperaDetails';
import DateRangePicker from './DateRangePricker';
import PieChartDetails from './PieChartDetails';
import StatsBoxes from './StatsBoxes';

interface IInsights {
    dateRange?: any;
    isOpen: boolean;
    setIsOpen: any;
    allStats: any;
    onChange: (e: any, type?: string) => void;
    onRefreshData: () => void;
}

const InsightsComponent = ({
    dateRange,
    isOpen,
    setIsOpen,
    allStats,
    onChange,
    onRefreshData,
}: IInsights) => {

    return (
        <div>
            <div className='flex flex-col sm:flex-row sm:justify-end sm:items-center'>
                <div className='bg-[#F3F3F3] p-1 flex flex-row justify-between items-center'>
                    <DateRangePicker
                        dateRange={dateRange}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        onChange={onChange}
                    />
                    {/* <p className='mx-5 text-primary-light text-sm  font-medium'>Showing {totalSessions || 0} Invoices</p> */}
                    <div onClick={onRefreshData} className='bg-white p-2 cursor-pointer hover:bg-gray-50 !rounded focus:bg-gray-100 ml-4'>
                        <img src={'/assets/shared/refresh.svg'} className='object-contain w-[16px]' />
                    </div>
                </div>
            </div>
            <StatsBoxes
                purchases={allStats?.purchases}
                statements={allStats?.statements}
                invoices={allStats?.invoices}
                discrepancies={allStats?.discrepancies}
            />
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-2 md:gap-4'>
                <div className=''>
                    <PieChartDetails
                        stats={allStats?.bankStats}
                        totalSessions={allStats?.bankStats?.totalTransactions}
                    />
                </div>
                <div className=''>
                    <PieChartOperaDetails
                        stats={allStats?.operaStats}
                        totalSessions={allStats?.operaStats?.totalTransactions}
                    />
                </div>

            </div>
        </div>
    )
}
export default InsightsComponent;